import http from './http';

//este token eh setado na Index.cshtml
var _token = window.__token_anjos;

let api = {

    getEstados() {
        return ["AC", "AL", "AM", "AP", "BA", "CE", "DF",
            "ES", "GO", "MA", "MG", "MS", "MT", "PA", "PB",
            "PE", "PI", "PR", "RJ", "RN", "RO", "RR",
            "RS", "SC", "SE", "SP", "TO"];
    },
    
    verificaSeCadastroVoluntarioEstaLiberado() {
        return new Promise((resolve, reject) => {
            var url = "/Anjos/VerificaSeCadastroVoluntarioEstaLiberado";
            http(url, {
                method: 'GET'

            }).then((response) => {
                resolve(response);
            }).catch(reject);
        });
    },
    
    getCidadesByUf: (uf) => {
        return new Promise((resolve, reject) => {
            var url = "/UnoesteApi/api/CEP/CEP/GetCidadesByUf?uf=" + uf;
            http(url, {
                method: 'GET',
                headers: {
                    'X-TOKEN': _token
                }
            }).then((response) => {
                resolve(response);
            }).catch(reject);
        });
    },

    getApoiadores: () => {
        return new Promise((resolve, reject) => {
            var url = "/Anjos/GetApoiadores";
            http(url, {
                method: 'GET'
            }).then((response) => {                
                resolve(response);
            }).catch(reject);
        });
    },

    getPessoasPorCpf: (cpf) => {
        return new Promise((resolve, reject) => {
            var url = "/UnoesteApi/api/Unoeste/Pessoa/RetornarPessoasPorCpf?cpf=" + cpf;
            http(url, {
                method: 'GET',
                headers: {
                    'X-TOKEN': _token
                }
            }).then((response) => {
                resolve({
                    dadosPessoa: response.pessoa,                  
                });
            }).catch(reject);
        });
    },


    consultaCEP: (cep) => {
        return new Promise((resolve, reject) => {
            var url = "/UnoesteApi/api/CEP/CEP/ConsultaCEP?cep=" + cep;
            http(url, {
                method: 'GET',
                headers: {
                    'X-TOKEN': _token
                }
            }).then((response) => {
                if (response.ExceptionMessage) {
                    reject(new Error(response.ExceptionMessage));
                    return;
                }
                /*
                    bairro : "Parque Residencial Servantes"
                    cidade : "Presidente Prudente" 
                    complemento : "" 
                    complemento2 : "" 
                    rua : "Rua Isaac Melem" 
                    uf : "SP
                */
                resolve(response);
            }).catch(reject);
        });
    },

    getQuestaoCasoPeriodoAtivo() {
        return new Promise((resolve, reject) => {
            var url = "/Anjos/GetQuestaoCasoPeriodoAtivo";
            http(url, {
                method: 'GET'

            }).then((response) => {
                resolve(response);
            }).catch(reject);
        });
    },

    gravarResposta( listRespostas) {
        return new Promise((resolve, reject) => {
            var url = "/Anjos/GravarRespostas";
            http(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: ({                 
                    listRespostas: listRespostas
                })
            }).then((response) => {
                resolve(response);
            }).catch(reject);
        });
    },

    getAreas() {
        return new Promise((resolve, reject) => {
            var url = "/Anjos/getAreas";
            http(url, {
                method: 'GET'
            }).then((response) => {
                resolve(response);
            }).catch(reject);
        });
    },

    
    gravarSolicitante(solicitante) {
        return new Promise((resolve, reject) => {
            var form = new FormData();
            solicitante = {...solicitante};
            delete  solicitante.listAreas;
            delete  solicitante.listCidades;
            delete  solicitante.listCidadesProjeto;
            delete  solicitante.listAreas;

            for(var p in solicitante){
                if(p === 'listAreasSelecionadas'){
                   form.append(p, (solicitante[p]).join(",") );
                   continue;
                }
                form.append(p, solicitante[p]);
            }
            var url = "/Anjos/GravarSolicitante";
            http(url, {
                headers: {
                    'X-TOKEN': _token
                },
                upload: true,                
                method: 'POST',
                body: form
            }).then((response) => {
                resolve(response);
            }).catch(reject);
        });
    },

    getLinkInscricaorefeicao: () => {
        return new Promise((resolve, reject) => {
            var url = "/Anjos/GetLinkInscricaoRefeicao";
            http(url, {
                method: 'GET'
            }).then((response) => {
                resolve({
                    linkInscricao: response.link,                  
                });
            }).catch(reject);
        });
    },
};




export default api;